package com.fireavert.units.delete_unit.client.presentation

data class DeleteUnitDialogViewState(
    val isOpen: Boolean = true,
    val isDeleting: Boolean = false
)
